const templateLandingFooter = document.createElement('template');

templateLandingFooter.innerHTML = `<footer class="footer secondary-bg fx mh-a">
                                        <span>Powered by <a href="https://www.adaptiveu.io/"> AdaptiveU ©</a> All rights reserved</span>
                                        <a href="https://www.adaptiveu.io/termsofuse"  class="ml-a link-item link hide">Terms & Conditions</a>
                                        <a href="https://www.adaptiveu.io/privacypolicy" class="link hide">Privacy Policy</a>
                                    </footer>`;

export default class LandingFooter extends HTMLElement {
  static get observedAttributes() {
    return ['page', 'semantic-name'];
  }

  connectedCallback() {
    this.appendChild(templateLandingFooter.content.cloneNode(true));
  }
}
